export const initializeSessionMutationQuery = `
      mutation initializeSessionMutation(
        $appId: String!
        $clientId: String!
        $clientSessionId: String
        $sessionId: String!
        $userAgent: String!
        $firstPage: String!
        $mixpanelDeviceId: String
        $referrerHostname: String
      ) {
        initializeSession(
          appId: $appId
          clientId: $clientId
          clientSessionId: $clientSessionId
          sessionId: $sessionId
          userAgent: $userAgent
          firstPage: $firstPage
          mixpanelDeviceId : $mixpanelDeviceId
          referrerHostname: $referrerHostname
      ) {
          sessionId
          inviteCode
          utmId
          partner {
            theme
            displayName
            primaryColor
            logo
            payload
            defaultFeeRate
            discountFeeRate
          }
        }
      }
    `;

export const updateUserSessionMutationQuery = `
      mutation initializeUserSessionMutation($appId: String!, $clientId: String!, $sessionId: String!, $clientSessionId: String!) {
        initializeUserSession(appId: $appId, clientId: $clientId, sessionId: $sessionId, clientSessionId: $clientSessionId) {
          sessionId
          inviteCode
          utmId
          partner {
            theme
            displayName
            primaryColor
            logo
            payload
            defaultFeeRate
            discountFeeRate
          }
        }
      }
    `;
